import { passwordArray, Passwordpattern } from "../patterns/Pattern";

export const PasswordValid = (name, value, nPassword, cPassword) => {
  let error = "";
  if (name === "password") {
    if (value === "") {
      error = "This field is required.";
      return { name: "password", error: error };
    }
    if (!Passwordpattern.test(value)) {
      error =
        " Password must be minimum 8 characters long and maximum 16 character long, contain at least one upper case letter, one lower case letter, one number, and one special character.";
      return { name: "password", error: error };
    }
    const isReservedUsername = passwordArray.some((reserved) =>
      value.toLowerCase().includes(reserved.toLowerCase())
    );
    if (isReservedUsername) {
      return {
        name: "password",
        error: "Password is too common. Please choose a more secure password.",
      };
    }
    if (cPassword !== "" && value) {
      if (value !== cPassword) {
        error = "Confirm password does't matched.";
        return [
          { name: "password", error: "" },
          { name: "confirmPassword", error: error },
        ];
      }
      // if(value === cPassword) {
      //   return { name: "confirmPassword", error: error };
      // }
      else {
        return [
          { name: "password", error: error },
          { name: "confirmPassword", error: error },
        ];
      }
    }
    return { name: "password", error: error };
  }
  if (name === "confirmPassword") {
    if (value === "") {
      error = "This field is required.";
      return { name: "confirmPassword", error: error };
    }
    if (nPassword !== "") {
      if (nPassword !== value) {
        error = "Confirm password does't matched.";

        return { name: "confirmPassword", error: error };
      }
    }
    return { name: "confirmPassword", error: error };
  }
};
